import { Text } from '~/components/ui/Text';
import { StyledCheckbox, StyledContainer, StyledTick } from './Checkbox.styled';

const Checkbox = ({
	value,
	onChange,
	text,
}: {
	value: boolean;
	onChange: (value: boolean) => void;
	text: string;
}) => {
	return (
		<StyledContainer>
			<StyledCheckbox $checked={value} onClick={() => onChange(!value)}>
				<StyledTick />
			</StyledCheckbox>
			<Text>{text}</Text>
		</StyledContainer>
	);
};

export { Checkbox };
